import { memo, useMemo } from 'react';
import { useAccount } from 'src/stores';
import { EAccountType, IBaseProps } from 'src/types';

interface IProps extends IBaseProps {
  roles: EAccountType[];
}

function PermissionAction({ children, roles }: IProps) {
  const { account } = useAccount();

  const hidden = useMemo<boolean>(() => {
    if (!account) return true;

    // Check permission
    if (!roles.includes(account.type)) return true;

    return false;
  }, [account]);

  if (hidden) return null;

  return children;
}

export default memo(PermissionAction);
